import { render, staticRenderFns } from "./ShareVideoAddModal.vue?vue&type=template&id=92827ee4&scoped=true&"
import script from "./ShareVideoAddModal.vue?vue&type=script&lang=js&"
export * from "./ShareVideoAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92827ee4",
  null
  
)

export default component.exports